import { render, staticRenderFns } from "./AltalanyPaidView.vue?vue&type=template&id=69e50a9a&scoped=true"
import script from "./AltalanyPaidView.vue?vue&type=script&lang=js"
export * from "./AltalanyPaidView.vue?vue&type=script&lang=js"
import style0 from "./AltalanyPaidView.vue?vue&type=style&index=0&id=69e50a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e50a9a",
  null
  
)

export default component.exports